/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { IMenuLocationModel } from '../../../../models/MenuLocation';
import FooterItem from '../../../footerItem';
import { Container, GetApp, BadgeContainer } from './footerAppLinksStyled';
import { E2ETestingProvider, E2E, getTestID } from '../../../../providers/e2eTestingProvider';

export interface IFooterAppLinks {
  menuLocation: IMenuLocationModel;
}

const FooterAppLinks: FunctionalComponent<IFooterAppLinks> = ({
  menuLocation: { parentItem: { anchorText } = {}, menuItemList },
}) => {
  const testIdPrefix = getTestID(E2E.project.suffix, E2E.section.footer, E2E.subsection.footer.app);

  return (
    <Container>
      <GetApp>{anchorText}</GetApp>
      <E2ETestingProvider testIdPrefix={testIdPrefix}>
        <BadgeContainer data-testid={getTestID(testIdPrefix, E2E.component.container)}>
          {menuItemList.map((item) => (
            <FooterItem item={item} key={item.id} />
          ))}
        </BadgeContainer>
      </E2ETestingProvider>
    </Container>
  );
};

export default FooterAppLinks;
